import React from "react";
import TextDetailHolder from "./text-detail-holder";
import moment from "moment";

const InvoiceCustomerDetailsContainer = ({
  customerName,
  customerNumber,
  customerPhoneNumber,
  customerEmail,
  location,
  invoiceDate,
  invoiceTableData,
}) => {
  return (
    <div className="invoice-customer-details-container">
      <div className="top-bar ">
        <div>
          <p className="title">Nigerian Civil Aviation Authority, Abuja</p>
          <p className="description">
            {invoiceTableData?.serviceTypeName
              ? invoiceTableData?.serviceTypeName
              : "-----"}
          </p>
        </div>
        <p className="date">
          Date:{" "}
          {invoiceDate ? moment(invoiceDate).format("DD/MM/YYYY") : "-----"}
        </p>
      </div>
      <div className="customer-dets grid grid-cols-4 gap-2 px-[26px] py-[20px]">
        <TextDetailHolder heading={"Name"} value={customerName} />
        <TextDetailHolder heading={"Customer No.:"} value={customerNumber} />
        <TextDetailHolder
          heading={"RRR:"}
          value={invoiceTableData?.RRR ? invoiceTableData?.RRR : "------"}
        />
        <TextDetailHolder heading={"Address:"} value={location} />
        <TextDetailHolder heading={"Customer Email:"} value={customerEmail} />
        <TextDetailHolder
          heading={"Customer Phone:"}
          value={customerPhoneNumber}
        />
      </div>
    </div>
  );
};

export default InvoiceCustomerDetailsContainer;
